/**
 * src/components/directory-page/SilverCard.js
 *
 * Tarjeta compacta Plan Plata — sin imagen.
 * Props: { id, name, category, location, whatsapp, rating, hasPromo }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { trackClick } from '@/shared/utils/track.js'
import { getReviewStats, getBusinessStats } from '@/services/reviewStats.js'
import { uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'

const stars = rating => '★'.repeat(Math.floor(rating)) + '☆'.repeat(5 - Math.floor(rating))

define('SilverCard', ({ id, name, category, location, whatsapp, rating, hasPromo }) => {
    return h('article', { className: 'silver-card' },
        h('div', { className: 'silver-card__left' },
            h('div', { className: 'silver-card__icon', innerHTML: uiIcons.store }),
            h('div', { className: 'silver-card__info' },
                h('p', { className: 'silver-card__category' }, category),
                h('h3', { className: 'silver-card__name' }, name),
                h('span', { className: 'silver-card__location', innerHTML: uiIcons.pin + ' ' + location })
            )
        ),
        h('div', { className: 'silver-card__right' },
            h('div', { className: 'silver-card__meta' },
                (() => {
                    const s = h('span', { className: 'silver-card__stars' }, stars(0))
                    getReviewStats().then(stats => {
                        const r = getBusinessStats(stats, id)
                        s.textContent = stars(r.avg) + (r.count ? ` (${r.count})` : '')
                    })
                    return s
                })(),
                hasPromo
                    ? h('span', { className: 'silver-card__promo', innerHTML: uiIcons.gift + ' Promo' })
                    : null
            ),
            h('div', { className: 'silver-card__actions' },
                h('a', {
                    className: 'silver-card__btn silver-card__btn--outline',
                    href: `/negocio/${id}`
                }, 'Ver negocio'),
                (() => {
                    const wa = h('a', {
                        className: 'silver-card__btn silver-card__btn--whatsapp',
                        href: waLink(whatsapp),
                        target: '_blank',
                        rel: 'noopener',
                        innerHTML: uiIcons.whatsapp + ' WhatsApp' })
                    wa.addEventListener('click', () => trackClick('business', id))
                    return wa
                })()
            )
        )
    )
})
